// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f97fbf7b","453":"769dcd23","455":"6fa40ec3","977":"ba0d75bd"}[chunkId] + ".chunk.js";
};